/** Dielectric picker: preset dropdown + editable er / tand. */
import type { DielProps } from "../model/fill";
import { DIELECTRIC_PRESETS, dielFromPreset } from "../model/materials";
import { issueFor } from "./common";

export function DielectricEdit(props: {
  value: DielProps;
  onChange: (d: DielProps) => void;
  path: string;
  compact?: boolean;
}) {
  const { value, onChange } = props;
  const erIssue = issueFor(`${props.path}.er`);
  const tandIssue = issueFor(`${props.path}.tand`);
  return (
    <span class={`diel-edit ${props.compact ? "compact" : ""}`}>
      <select
        title="Material preset"
        value={value.presetId ?? "custom"}
        onChange={(e) => {
          const id = (e.target as HTMLSelectElement).value;
          if (id !== "custom") onChange(dielFromPreset(id));
        }}
      >
        {DIELECTRIC_PRESETS.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
        <option value="custom">Custom</option>
      </select>
      <input
        type="number"
        title="Relative permittivity εr"
        step={0.05}
        min={1}
        value={value.er}
        class={erIssue?.severity === "error" ? "invalid" : ""}
        onInput={(e) => {
          const v = parseFloat((e.target as HTMLInputElement).value);
          if (Number.isFinite(v)) onChange({ er: v, tand: value.tand });
        }}
      />
      <input
        type="number"
        title="Loss tangent tanδ"
        step={1e-4}
        min={0}
        value={value.tand}
        class={tandIssue?.severity === "error" ? "invalid" : ""}
        onInput={(e) => {
          const v = parseFloat((e.target as HTMLInputElement).value);
          if (Number.isFinite(v)) onChange({ er: value.er, tand: v });
        }}
      />
    </span>
  );
}
